import { IMediaAndContent } from '../../interfaces/MediaAndContent'
import DateWithIcon from '../Common/DateWithIcon';
import ChipsMapper from '../Mappers/ChipsMapper';
const { REACT_APP_BACKOFFICE_CONNECTION, REACT_APP_BACKOFFICE_FILE_UPLOAD_PATH } = process.env;

const MediaAndContentLarge = ({ imagen, titulo, descripcion, categorias, fecha }: IMediaAndContent) => {

    return (
        <div className='md:h-[14rem] flex flex-col md:flex-row gap-4 border border-system-light-20 rounded-lg2 bg-system-light-10 cursor-pointer hover:shadow-custom-dual'>
            <div className='md:w-[24.875rem]'>
                <img
                    src={`${REACT_APP_BACKOFFICE_CONNECTION}${REACT_APP_BACKOFFICE_FILE_UPLOAD_PATH}${imagen.replace("files/", "")}`}
                    alt={imagen.replace("files/", "")}
                    className='h-[11.549rem] sm:h-[18.803rem] md:h-full w-full md:min-w-[24.875rem] object-cover md:object-fill rounded-t-lg2 md:rounded-l-lg2 md:rounded-tr-none'
                />
            </div>
            <div className='h-[14.125rem] md:h-full flex flex-col justify-between px-4 md:p-0'>
                <div className='md:pr-4 md:py-4 flex flex-col gap-2 md:gap-3'>
                    <h2 className='text-tmedium text-system-light-100'>{titulo}</h2>
                    <ChipsMapper categorias={categorias} />
                    <p className='text-bmedium text-system-light-100 lg:text-system-light-40 line-clamp-3'>{descripcion}</p>
                </div>
                <div className='flex gap-6 mt-2 md:mt-0 mb-4'>
                    <DateWithIcon date={fecha} />
                </div>
            </div>
        </div>
    )
}

export default MediaAndContentLarge